<template>
  <path stroke-linecap="square" d="M22.5 3.5v19M22.5 22.5h-19"/>
  <path d="M22.5 22.5.5.5"/>
</template>
